// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:36.250Z
// Property: The Colonies at Hillside (ID: 6767906449167037)
// Collections: 24 amenities, 8 floorplans (live), 15 photos, 66 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167037",
  "property_external_id": "48310",
  "property_zillow_url": "https://www.zillow.com/apartments/amarillo-tx/the-colonies-at-hillside/5XhtHx/",
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Colonies+at+Hillside/data=!4m2!3m1!1s0x0:0x7a8032673c434373?sa=X&ved=2ahUKEwiV2KSlgoOTAxWij2oFHTuVOV0Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-colonies-at-hillside",
  "property_name": "The Colonies at Hillside",
  "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/colonies-at-hillside/",
  "property_domain": null,
  "property_address": "7550 S. Hillside Road",
  "property_full_address": "7550 S. Hillside Road, Amarillo, TX, 79119",
  "property_address_1": "7550 S. Hillside Road",
  "property_address_2": null,
  "property_address_city": "Amarillo",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79119",
  "property_address_country": "US",
  "property_address_county": "Randall County",
  "property_neighborhood_address": null,
  "property_address_latitude": "35.1484",
  "property_address_longitude": "-101.9233",
  "property_email": "coloniesathillside@caseusa.com",
  "property_phone": "(806) 304-6308",
  "property_call_tracking_phone": "844-243-8338",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to The Colonies at Hillside, where modern comfort meets style in Amarillo, TX. Choose from spacious one or two-bedroom layouts, complete with lofty ceilings and private balconies. Enjoy resort-style amenities like a shimmering pool, scenic BBQ areas, and a vibrant bark park—perfect for both relaxation and recreation. Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Colonies at Hillside, your ideal apartment community in the heart of Amarillo, TX! Our beautifully designed one and two-bedroom floor plans offer the perfect balance of style and convenience, catering to a variety of lifestyles. With bright and open layouts featuring spacious options and loft-style living available, you’ll find a space that feels like home. Enjoy modern amenities such as ceramic tile in the kitchen and bath, fully equipped kitchens, and the luxury of a private balcony or patio in select units.\n\nResort-style living awaits you with our stunning swimming pool, surrounded by beautifully landscaped courtyards and barbecue picnic areas perfect for gatherings with friends and family. Stay fit in our 24-hour fitness center or take advantage of our business center and cyber café for your professional needs. Our community ensures your peace of mind with limited-access gates, 24-hour emergency maintenance, and professional onsite management.\n\nConvenience is key at The Colonies at Hillside, with easy access to I-40 and I-27, making commuting a breeze. Enjoy the perks of covered garage parking, flexible payment options, and online rental payments. Plus, your furry friends will love our bark park! \n\nFind your new home today at The Colonies at Hillside. Explore our availability or schedule a tour to discover the exceptional lifestyle that awaits you in Amarillo!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-7643-74ed-a9f7-5320d688a856.webp",
  "property_featured_image_media": {
    "alt_text": "The Colonies at Hillside apartment complex entrance with signage and building exteriors.",
    "public_id": "019cfb50-7643-74ed-a9f7-5320d688a856",
    "storage_key": "property/6767906449167037/019cfb50-7643-74ed-a9f7-5320d688a856.webp",
    "width": 1600,
    "height": 1060
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "42",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "yes",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://coloniesathillsideapartmentsamarillo.securecafe.com/onlineleasing/the-colonies-at-hillside/floorplans.aspx",
  "property_resident_portal_url": "https://coloniesathillsideapartmentsamarillo.securecafe.com/residentservices/the-colonies-at-hillside/userlogin.aspx",
  "property_apply_now_url": "https://coloniesathillsideapartmentsamarillo.securecafe.com/onlineleasing/the-colonies-at-hillside/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
  "property_primary_logo_media": {
    "alt_text": "Colonies at Hillside logo",
    "public_id": "019d9bd5-6e35-734f-a660-3e0744b6819f",
    "storage_key": "property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
    "width": 371,
    "height": 234
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d9bd6-6b5c-75bc-a860-8678dab5b896.webp",
  "property_secondary_logo_media": {
    "alt_text": "Colonies @ Hillside logo with a bull and orange sun.",
    "public_id": "019d9bd6-6b5c-75bc-a860-8678dab5b896",
    "storage_key": "property/6767906449167037/019d9bd6-6b5c-75bc-a860-8678dab5b896.webp",
    "width": 371,
    "height": 234
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Colonies at Hillside logo",
    "public_id": "019d9bd5-6e35-734f-a660-3e0744b6819f",
    "storage_key": "property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
    "width": 371,
    "height": 234
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Colonies at Hillside logo",
    "public_id": "019d9bd5-6e35-734f-a660-3e0744b6819f",
    "storage_key": "property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
    "width": 371,
    "height": 234
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#474d43",
  "property_secondary_color": "#f9ac24",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "805 - 1145",
  "property_sqft_min": "805",
  "property_sqft_max": "1145",
  "property_price_range": "1474 - 1604",
  "property_price_min": "1474",
  "property_price_max": "1604",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/TheColoniesAtHillside/photos/d41d8cd9/862796933787106/",
  "property_instagram_url": "https://www.instagram.com/coloniesathillside/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJwz00t4JaAYcRc0NDPGcygHo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/homestyle-suites-amarillo",
  "property_tiktok_url": "https://www.tiktok.com/discover/the-colonies-at-hillside-apartments-in-amarillo",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Colonies at Hillside",
  "property_home_romance_title": "Embrace Your Ideal Living Experience, Discover Home Today!",
  "property_home_amenities_blurb": "Welcome to The Colonies at Hillside, where modern living meets comfort in Amarillo, TX. Choose from our spacious one and two-bedroom floor plans, complete with stylish finishes and vaulted ceilings. Enjoy resort-style amenities like a shimmering swimming pool, barbecue areas, and a vibrant bark park. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to The Colonies at Hillside in vibrant Amarillo, TX, where comfort meets style. With a variety of thoughtfully designed floor plans, you’ll find the ideal space to call home. Browse our available apartment homes today and envision the lifestyle that awaits you in our welcoming community.",
  "property_home_gallery_blurb": "At The Colonies at Hillside in Amarillo, TX, vibrant living awaits. Choose from spacious one and two-bedroom floor plans featuring vaulted ceilings and private patios. Enjoy resort-style amenities like a shimmering pool, landscaped courtyards, and a lively bark park. Picture yourself thriving in this inviting community!",
  "property_home_neighborhood_blurb": "Welcome to The Colonies at Hillside, where vibrant living meets convenience in Amarillo, TX. Nestled near the Amarillo Museum of Art and the serene Amarillo Botanical Gardens, our community offers easy access to urban parks, engaging learning centers like Amarillo College, and thrilling adventures at Urban Air Trampoline Park. Experience life your way!",
  "property_home_reviews_blurb": "At The Colonies at Hillside in Amarillo, TX, residents rave about their experience, saying, “The welcoming atmosphere and incredible staff make it feel like home.” Embrace a vibrant community where comfort meets convenience. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At The Colonies at Hillside in Amarillo, TX, vibrant living meets convenient access. Immerse yourself in culture at the Amarillo Museum of Art or enjoy nature at Wildcat Bluff Nature Center. With nearby parks, fitness options, and local attractions, your ideal lifestyle awaits. Uncover the charm of your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Colonies at Hillside in Amarillo, TX, enrich your lifestyle with exceptional amenities like resort-inspired swimming pools, beautifully landscaped courtyards, and a vibrant bark park. Choose from spacious one- or two-bedroom floor plans featuring vaulted ceilings and private patios—your perfect retreat awaits! ",
  "property_applynow_blurb": "Welcome to The Colonies at Hillside in Amarillo, TX, where comfort meets style. Choose from spacious one or two-bedroom floor plans featuring vaulted ceilings and private patios. Enjoy resort-style amenities, including a sparkling pool, barbecue areas, and a bark park. Elevate your lifestyle—secure your new home online today!",
  "property_contactus_blurb": "At The Colonies at Hillside in Amarillo, TX, our thoughtfully designed floor plans offer both one and two-bedroom options, perfect for your lifestyle. Whether you crave cozy comfort or spacious elegance, we have the ideal space waiting for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At The Colonies at Hillside in Amarillo, TX, we offer a variety of thoughtfully designed floor plans, including one and two-bedroom options, tailored to fit your lifestyle. Have questions? Our FAQs page provides valuable insights to help you navigate our vibrant community effortlessly. ",
  "property_floorplans_blurb": "At The Colonies at Hillside in Amarillo, TX, you’ll find thoughtfully designed floor plans to match your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom suites. Every home invites comfort and style. Browse our available apartment homes and uncover the perfect space that feels uniquely yours. ",
  "property_gallery_blurb": "At The Colonies at Hillside in Amarillo, TX, envision a vibrant lifestyle with spacious, loft-style apartments featuring bright floor plans and vaulted ceilings. Enjoy resort-inspired amenities like a sparkling pool, well-appointed fitness center, and serene barbeque areas. Picture yourself relaxing on your private balcony or patio—your new sanctuary awaits!",
  "property_interactivemap_blurb": "At The Colonies at Hillside in Amarillo, TX, vibrant living meets modern convenience. Choose from spacious one and two-bedroom floor plans featuring resort-style amenities like a sparkling swimming pool, beautifully landscaped courtyards, and a 24-hour fitness center. Utilize our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to The Colonies at Hillside in Amarillo, TX, where modern living meets comfort. Our vibrant community invites you and your furry friends to enjoy stylish apartments amidst lush landscapes. Experience a haven tailored to your lifestyle—reach out to our leasing office for pet policy details and begin your new adventure today!",
  "property_referafriend_blurb": "At The Colonies at Hillside in Amarillo, TX, your perfect home awaits! Choose from spacious one and two-bedroom floor plans, designed for comfort and style. Great friends make great neighbors—invite someone special to share in the vibrant community experience. Refer a friend today and foster new connections!",
  "property_residentaccess_blurb": "Welcome to The Colonies at Hillside in Amarillo, TX, where comfort meets convenience. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Log in to your resident portal today to manage rent, request maintenance, and embrace the ease of modern living!",
  "property_reviews_blurb": "Residents at The Colonies at Hillside rave about their experience, with one noting, \"The caring staff and beautiful surroundings make this community a home.\" Nestled in Amarillo, TX, our apartment community boasts a blend of comfort and connection. See what our residents have to say about living at our community!",
  "property_created_at": "1770655841420",
  "property_scheduletour_blurb": "At The Colonies at Hillside in Amarillo, TX, our thoughtfully designed one and two-bedroom floor plans offer a perfect blend of comfort and style. Ready to find your ideal living space? Schedule a tour today and hear firsthand from our residents about the vibrant lifestyle in our welcoming community!",
  "property_thankyou_blurb": "Thank you for your interest in The Colonies at Hillside in Amarillo, TX! We offer a variety of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom apartments. Our team will reach out soon to help you find your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "Step into modern living at The Colonies at Hillside in Amarillo, TX. Our thoughtfully designed one and two-bedroom floor plans blend comfort with style. Unveil the charm of your future home—take a virtual tour today and envision life in our vibrant community!",
  "property_copyright": "2026 All Rights Reserved. The Colonies at Hillside",
  "property_seo_title_home": "The Colonies at Hillside |  Apartments in Amarillo, TX",
  "property_seo_description_home": "Experience vibrant living at The Colonies at Hillside in Amarillo, TX! Enjoy spacious apartments, resort-style amenities, and easy access to I-40 and I-27.",
  "property_seo_title_floorplans": "Floor Plans | Amarillo, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Colonies at Hillside in Amarillo, TX! Choose from one and two-bedroom floor plans tailored for comfort and style.",
  "property_seo_title_amenities": "Amenities | Amarillo, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at The Colonies at Hillside! Enjoy beautiful courtyards, resort-style pools, and modern apartments in Amarillo, TX.",
  "property_seo_title_gallery": "Gallery | Apartments in Amarillo, TX",
  "property_seo_description_gallery": "Picture life at The Colonies at Hillside in Amarillo, TX! Luxe amenities, stunning floor plans, and scenic courtyards await you. Your dream home is here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Colonies at Hillside Apartments",
  "property_seo_description_virtualtours": "Step inside The Colonies at Hillside in Amarillo, TX! Take a virtual tour and envision your ideal one or two-bedroom apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | The Colonies at Hillside Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Colonies at Hillside in Amarillo, TX! Use our interactive map to explore spacious floor plans and enjoy top-notch amenities today.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Amarillo, TX",
  "property_seo_description_neighborhood": "Uncover the charm of The Colonies at Hillside in Amarillo, TX! Dive into our vibrant neighborhood and find local favorites just steps from your new home.",
  "property_seo_title_contact": "Contact Us | The Colonies at Hillside",
  "property_seo_description_contact": "Connect with The Colonies at Hillside in Amarillo, TX! Inquire about our spacious one and two-bedroom floor plans. Your ideal home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Amarillo, TX",
  "property_seo_description_faqs": "Find peace of mind at The Colonies at Hillside in Amarillo! Check our FAQs for insights on floor plans, amenities, and everything you need for comfy living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Amarillo, TX",
  "property_seo_description_reviews": "Discover The Colonies at Hillside in Amarillo, TX! Enjoy stunning amenities, flexible living, and a vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Amarillo, TX",
  "property_seo_description_applynow": "Experience luxury living at The Colonies at Hillside in Amarillo, TX! Enjoy spacious floor plans, a resort-style pool, and modern amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Colonies at Hillside",
  "property_seo_description_residentaccess": "Unlock convenience at The Colonies at Hillside! Log in to access your resident portal for rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Colonies at Hillside",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Colonies at Hillside in Amarillo, TX, and enjoy a thriving community together. Share the joy!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Colonies at Hillside",
  "property_seo_description_scheduletour": "Experience the charm of The Colonies at Hillside in Amarillo, TX. Schedule a tour today and find your perfect home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Colonies at Hillside",
  "property_seo_description_privacy": "Your privacy matters at The Colonies at Hillside. Review our commitment to protecting your information in Amarillo, TX. Transparent. Secure. Find out more!",
  "property_seo_title_accessibility": "Website Accessibility | The Colonies at Hillside",
  "property_seo_description_accessibility": "At The Colonies at Hillside in Amarillo, TX, we prioritize inclusivity, ensuring every community member feels at home through our accessibility commitment.",
  "property_seo_title_sitemap": "Sitemap | The Colonies at Hillside",
  "property_seo_description_sitemap": "Navigate your way to comfort at The Colonies at Hillside in Amarillo, TX. Check out our sitemap for a seamless journey through our vibrant apartment community!",
  "property_seo_title_thankyou": "Thank You | The Colonies at Hillside",
  "property_seo_description_thankyou": "Thank you for connecting with The Colonies at Hillside! A team member will reach out soon to help you find your perfect Amarillo apartment home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Amarillo, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865910026",
  "amenities": [
    {
      "id": "ec_a39acb985f2c0d4b50589f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397247",
      "title": "Beautifully Landscaped Courtyards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e8a7e3b0a9a33e343bc7277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397248",
      "title": "Limited-Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b58c2b5aeb1208c9131505b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397249",
      "title": "Resort-Inspired Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90f2b15ed1285701dedf7b72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397250",
      "title": "Business Center & Cyber Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f11cf2e4b35261f843796134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397251",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28645f0ebe76d4b7f0e9ad4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397252",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc287be738eed5c93b87d453",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397253",
      "title": "Covered Garage Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_263b4b8db3f2f04d358b69f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397254",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_693dbb7510b5912b2b69d37f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397255",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bfb20e67532bd3038d8310f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397256",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fdd983eee1cc2bb82529232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397257",
      "title": "Professional Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_366a5882672789e4adeba9ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397258",
      "title": "Easy Access to I-40 and I-27",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7967d2476abc90a140ed0837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397259",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_869b20aa47e841ea59dcbdcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127397260",
      "title": "Loft Style Living Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0585db4127fc767fc37aa0c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398718",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_076c8bfce213fc159014ae5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398719",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_393e5fda2cbd84cd17eaf158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398720",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaa144d8c8f1ab358c65786d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398721",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d8a0c3e3cfb6062eebc821f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398722",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cb24feb84fc151f2098a72f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398723",
      "title": "In-Home Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d0dbfa3680f65378458d069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398724",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edbf5a88e4cdd1e4a4b416f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398725",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6b5f6e4b1400aabe5d58262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398726",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bc04ba5f49271d78a529454",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "yardi",
      "external_id": "127398727",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2504e25a-63a3-4ce4-9fcc-9b1ccddc41b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-7c48-769a-8ee6-223c20f14478.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily community entrance with a brick sign and landscaped roundabout.",
        "public_id": "019d20b9-7c48-769a-8ee6-223c20f14478",
        "storage_key": "property/6767906449167037/019d20b9-7c48-769a-8ee6-223c20f14478.webp",
        "width": 1600,
        "height": 1060
      },
      "title": "Community",
      "description": "Exterior of The Colonies at Hillside, showing a brick entry monument, circular drive, and well-kept landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multifamily community entrance with a brick sign and landscaped roundabout.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7643-74ed-a9f7-5320d688a856.webp"
    },
    {
      "id": "custom_d47612fb-77fa-4377-a02b-cd385c7f6c05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-7cb3-7348-8d28-fc4ecc70184e.webp",
      "image_media": {
        "alt_text": "Exterior view of The Colonies at Hillside community entrance with a landscaped roundabout and brick sign.",
        "public_id": "019d20b9-7cb3-7348-8d28-fc4ecc70184e",
        "storage_key": "property/6767906449167037/019d20b9-7cb3-7348-8d28-fc4ecc70184e.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of The Colonies at Hillside, showing the community entrance with a brick sign and surrounding landscaping.",
      "link": "",
      "alt_text": "Exterior view of The Colonies at Hillside community entrance with a landscaped roundabout and brick sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-5832-75bc-948a-a0471ea5bc08.webp"
    },
    {
      "id": "custom_4e0cbb32-c0ca-4348-9d00-7a25530c582a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-7d47-7179-92f3-18edf187347b.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with orange chairs and grills at an apartment complex.",
        "public_id": "019d20b9-7d47-7179-92f3-18edf187347b",
        "storage_key": "property/6767906449167037/019d20b9-7d47-7179-92f3-18edf187347b.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Cozy outdoor grilling area with high-top orange chairs and built-in grills in the apartment community courtyard.",
      "link": "",
      "alt_text": "Outdoor community grilling area with orange chairs and grills at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7613-75a5-aa58-daadfd88afd5.webp"
    },
    {
      "id": "custom_f38e2cfd-576c-4983-af6c-87e09a4052c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-7cb7-74dd-ace7-f75cb10bef23.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with curved pool, orange lounge chairs, and a clubhouse in the background.",
        "public_id": "019d20b9-7cb7-74dd-ace7-f75cb10bef23",
        "storage_key": "property/6767906449167037/019d20b9-7cb7-74dd-ace7-f75cb10bef23.webp",
        "width": 1600,
        "height": 1060
      },
      "title": "Community",
      "description": "Pool and clubhouse scene at a multifamily community with lounge seating and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor pool area with curved pool, orange lounge chairs, and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-762b-70d8-8d27-631e85faeb79.webp"
    },
    {
      "id": "custom_a635ee51-e216-4cb2-b0b1-f06bcf7d6243",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-85c3-777e-8521-64a9c30e2d82.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue-tiled deck, yellow lounge chairs, and apartment buildings in the background.",
        "public_id": "019d20b9-85c3-777e-8521-64a9c30e2d82",
        "storage_key": "property/6767906449167037/019d20b9-85c3-777e-8521-64a9c30e2d82.webp",
        "width": 650,
        "height": 434
      },
      "title": "Community",
      "description": "Outdoor pool area at our apartment community, featuring a blue-tiled pool, lounge seating, and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor community pool with blue-tiled deck, yellow lounge chairs, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-8101-75cf-999d-b26874c2bd4b.webp"
    },
    {
      "id": "custom_1cdc1945-ec2c-437b-994e-5f573cfdd35c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-875a-775d-a97d-84acdc7b44bd.webp",
      "image_media": {
        "alt_text": "Home office in an apartment with a large window, two desks, orange chairs, and multiple monitors.",
        "public_id": "019d20b9-875a-775d-a97d-84acdc7b44bd",
        "storage_key": "property/6767906449167037/019d20b9-875a-775d-a97d-84acdc7b44bd.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment office featuring two workstations, orange seating, and a wall-mounted TV.",
      "link": "",
      "alt_text": "Home office in an apartment with a large window, two desks, orange chairs, and multiple monitors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7617-70bd-8917-42d1cf37fb4a.webp"
    },
    {
      "id": "custom_ad16e1a4-684e-408f-8d08-2fef28ea88b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-87c9-70aa-928f-9bce3e7f717c.webp",
      "image_media": {
        "alt_text": "Interior of a community gym with treadmills, weights, and benches.",
        "public_id": "019d20b9-87c9-70aa-928f-9bce3e7f717c",
        "storage_key": "property/6767906449167037/019d20b9-87c9-70aa-928f-9bce3e7f717c.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "On-site fitness center for residents featuring cardio machines, free weights, benches, and functional training equipment.",
      "link": "",
      "alt_text": "Interior of a community gym with treadmills, weights, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-761f-737a-9e54-9f82c8549a03.webp"
    },
    {
      "id": "custom_03199c8d-4cae-4a65-a205-cc74e5197a5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-90de-756c-b925-6542fa57f2b3.webp",
      "image_media": {
        "alt_text": "Bright interior of a community fitness center with treadmills, weight machines, and free weights.",
        "public_id": "019d20b9-90de-756c-b925-6542fa57f2b3",
        "storage_key": "property/6767906449167037/019d20b9-90de-756c-b925-6542fa57f2b3.webp",
        "width": 698,
        "height": 797
      },
      "title": "Community",
      "description": "Interior view of the property's fitness center, featuring cardio machines, strength equipment, and a bright open layout.",
      "link": "",
      "alt_text": "Bright interior of a community fitness center with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7e48-71fe-8b05-8db26c5656a1.webp"
    },
    {
      "id": "custom_f561329f-18cd-4929-b3e7-619a9530d9f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-942b-7359-8faf-51efbfe57723.webp",
      "image_media": {
        "alt_text": "Living room in a model apartment with large windows, a green sofa, and a dining area.",
        "public_id": "019d20b9-942b-7359-8faf-51efbfe57723",
        "storage_key": "property/6767906449167037/019d20b9-942b-7359-8faf-51efbfe57723.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright, modern living space in a model apartment with large windows, a green sofa, and a dining area.",
      "link": "",
      "alt_text": "Living room in a model apartment with large windows, a green sofa, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7613-75a5-aa58-d02f659c6717.webp"
    },
    {
      "id": "custom_186243f4-9906-42d0-a602-76295ed4ea69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-9a4e-76c5-b28f-e1a8693919a7.webp",
      "image_media": {
        "alt_text": "Dining area in a modern apartment with a gray table, chairs, plant, and wall art near a door with blinds.",
        "public_id": "019d20b9-9a4e-76c5-b28f-e1a8693919a7",
        "storage_key": "property/6767906449167037/019d20b9-9a4e-76c5-b28f-e1a8693919a7.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright dining area in a stylish apartment, featuring a gray dining table, contemporary chairs, a plant, and abstract wall art.",
      "link": "",
      "alt_text": "Dining area in a modern apartment with a gray table, chairs, plant, and wall art near a door with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-7613-75a5-aa58-d7bd24d8ddc7.webp"
    },
    {
      "id": "custom_b7c794c6-fe4b-4297-afd6-a97aab3a69ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-9ab9-7281-881f-10779601821c.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with brown wooden cabinets, white fridge and stove, and a granite island.",
        "public_id": "019d20b9-9ab9-7281-881f-10779601821c",
        "storage_key": "property/6767906449167037/019d20b9-9ab9-7281-881f-10779601821c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen with granite countertops, wooden cabinets, and full-size appliances.",
      "link": "",
      "alt_text": "Kitchen in an apartment with brown wooden cabinets, white fridge and stove, and a granite island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-762b-70d8-8d27-5dc7c0b9c4fb.webp"
    },
    {
      "id": "custom_580a306d-78a0-4a33-9747-2974187c0f84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-a44d-71d5-9e54-6a0094e2ed81.webp",
      "image_media": {
        "alt_text": "Aerial city skyline at sunset with tall buildings and glowing streetlights.",
        "public_id": "019d20b9-a44d-71d5-9e54-6a0094e2ed81",
        "storage_key": "property/6767906449167037/019d20b9-a44d-71d5-9e54-6a0094e2ed81.webp",
        "width": 1998,
        "height": 699
      },
      "title": "Lifestyle",
      "description": "A panoramic aerial view of downtown at dusk, featuring a central tall building and twinkling lights—perfect for a modern apartment community.",
      "link": "",
      "alt_text": "Aerial city skyline at sunset with tall buildings and glowing streetlights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-88f7-71e4-bcf7-5de0c8789ae5.webp"
    },
    {
      "id": "custom_99e3801b-3677-49e5-864a-7d2c1228dbd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-a41e-7358-a942-44ca21b9b22f.webp",
      "image_media": {
        "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
        "public_id": "019d20b9-a41e-7358-a942-44ca21b9b22f",
        "storage_key": "property/6767906449167037/019d20b9-a41e-7358-a942-44ca21b9b22f.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a person holding a travel mug beside a bicycle, suggesting an active, outdoor-friendly community.",
      "link": "",
      "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-8a24-7379-a18f-0bfd763cfcfb.webp"
    },
    {
      "id": "custom_b9210341-9bf6-4af1-b5ba-07d20143953a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-a5d5-768c-983c-69e9b42835a0.webp",
      "image_media": {
        "alt_text": "Children with backpacks boarding a yellow school bus outdoors.",
        "public_id": "019d20b9-a5d5-768c-983c-69e9b42835a0",
        "storage_key": "property/6767906449167037/019d20b9-a5d5-768c-983c-69e9b42835a0.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Children with backpacks line up to board a yellow school bus outdoors.",
      "link": "",
      "alt_text": "Children with backpacks boarding a yellow school bus outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-8aa5-7158-9808-64bfe2f69213.webp"
    },
    {
      "id": "custom_6ca8dcda-0172-4f85-b0cc-840d7fb43b2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d20b9-ac40-76b1-9137-e9a7ff681cfc.webp",
      "image_media": {
        "alt_text": "Exterior brick storefronts with awnings in a pedestrian plaza, with people walking.",
        "public_id": "019d20b9-ac40-76b1-9137-e9a7ff681cfc",
        "storage_key": "property/6767906449167037/019d20b9-ac40-76b1-9137-e9a7ff681cfc.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "A vibrant outdoor courtyard with brick storefronts, awnings, and pedestrian activity within the community.",
      "link": "",
      "alt_text": "Exterior brick storefronts with awnings in a pedestrian plaza, with people walking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167037/019cfb50-8c37-70da-97e4-84c724c44ecd.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e8e78518-eaf7-49a2-b379-05d593f8d125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2805 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tender chicken fried steak, delicious ribs, and flavorful ribeye steaks. They highlight the generous portions, reasonable prices, and the legendary rolls with cinnamon butter. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-9e87-739c-b706-5673cbf723a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9e87-739c-b706-5673cbf723a5",
        "storage_key": "property/6767906449167037/019cfb50-9e87-739c-b706-5673cbf723a5.webp",
        "width": 1280,
        "height": 1256
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328858651283659231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.1940532",
      "poi_longitude": "-101.8676751",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-352-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQj8GMpPAYcR35k_aU57Mi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_517ca690-79e0-4f17-92c5-6f40fb4ff6d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "2813 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, pizza, wings, and fried pickles. They highlight the generous portions, reasonable prices, and fun, lively atmosphere with TVs and music. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e59f-7554-b4f8-db45fad42787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e59f-7554-b4f8-db45fad42787",
        "storage_key": "property/6767906449167037/019cfb50-e59f-7554-b4f8-db45fad42787.webp",
        "width": 1280,
        "height": 1121
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15317791946731671629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "35.1937663",
      "poi_longitude": "-101.8691615",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-353-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD99rJspPAYcRTdBHUJ66k9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b5014869-1b06-432e-a6b3-787ef9aee833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2812 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken tenders, toast, and fries. They highlight the food is always hot, fresh, and flavorful, and the service is fast and efficient. They also like the friendly staff and the clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-9a22-7049-b7ae-74c3ab59e60d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9a22-7049-b7ae-74c3ab59e60d",
        "storage_key": "property/6767906449167037/019cfb50-9a22-7049-b7ae-74c3ab59e60d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/amarillo/2812-s-georgia-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=905577921826965201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.1828248",
      "poi_longitude": "-101.8668346",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-356-0140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUy4qoxPAYcR0cbualJCkQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6e218a55-febf-444e-8054-d4fd387b6627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "7220 I-40, Amarillo, TX 79106, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including steak, meatloaf, and a salad bar. They also highlight the friendly staff and the clean, comfortable atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e57e-7579-99ce-5586e086a3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e57e-7579-99ce-5586e086a3c0",
        "storage_key": "property/6767906449167037/019cfb50-e57e-7579-99ce-5586e086a3c0.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/533/golden-corral-interstate-40-west?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=533",
      "poi_directions_map_url": "https://maps.google.com/?cid=9190004277535110809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "35.18741079999999",
      "poi_longitude": "-101.9189781",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-353-3779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlV3avU5QAYcRmfbMHjN0iX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_8bef1ff2-ec47-4d06-84c9-5bfb987bb756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2525 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken sandwiches, nuggets, and lemonade. They highlight the friendly and attentive staff, and the quick service. They also like the clean atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e5d7-7479-a805-02e5dd0763c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e5d7-7479-a805-02e5dd0763c4",
        "storage_key": "property/6767906449167037/019cfb50-e5d7-7479-a805-02e5dd0763c4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/georgia-street?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898565818159840665&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.18604200000001",
      "poi_longitude": "-101.8656726",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-358-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_QXe7hPAYcRmb09sSrFXok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5688c6f8-44ca-4d65-9597-7899c2f233b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Westgate Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 I-40, Amarillo, TX 79121, USA",
      "poi_short_description": "Brand-name retail stores, fast-food outlets, a cinema & mini-golf course are the draw at this mall.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and choices. They also highlight the clean and well-maintained environment, and the fun, vibrant atmosphere.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-b790-7180-8d75-72af2dfaa0ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b790-7180-8d75-72af2dfaa0ea",
        "storage_key": "property/6767906449167037/019cfb50-b790-7180-8d75-72af2dfaa0ea.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://www.westgatemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8872045046986861251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westgate-mall",
      "poi_latitude": "35.184043",
      "poi_longitude": "-101.9280617",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-7221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c26b-708b-a448-3b0c9a8c506a",
        "storage_key": "property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5aNuwVBQAYcRw2rq0PbVH3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f2812cd5-c4bd-4da1-9f30-cb6492a2b2ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products for DIY projects and home renovations. They also highlight the helpful and knowledgeable staff, and the good prices.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e5cf-7168-a136-f78d34b38c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e5cf-7168-a136-f78d34b38c83",
        "storage_key": "property/6767906449167037/019cfb50-e5cf-7168-a136-f78d34b38c83.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/E-Amarillo/TX/Amarillo/79109/6831?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449643067838617860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.1887022",
      "poi_longitude": "-101.8687317",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-468-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c26b-708b-a448-3b0c9a8c506a",
        "storage_key": "property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_XrzAchPAYcRBNngA-uVKfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a973ed15-5d00-4186-a905-ed0be85cfb91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chains and department retailer featuring clothing and footwear, plus housewares and gifts.",
      "poi_long_description": "People say this clothing store offers a wide selection of labeled clothing, perfume, and gifts. They also highlight the great prices and the availability of a big and tall section.\n\nOther reviews mention the customer service can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e563-7111-8f8c-41c52cddfea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e563-7111-8f8c-41c52cddfea2",
        "storage_key": "property/6767906449167037/019cfb50-e563-7111-8f8c-41c52cddfea2.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/tx/amarillo/564/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13172599468811409494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.1892288",
      "poi_longitude": "-101.8809655",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-353-7087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c26b-708b-a448-3b0c9a8c506a",
        "storage_key": "property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQYcDKddPAYcRVtgA62x5zrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_2a24cab5-5be4-47b3-8efa-db4db52bc96d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "2530 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean grocery store that’s stocked with national brands alongside local ingredients, and has an on-site bakery and deli.",
      "poi_long_description": "People say this grocery store offers a wide selection of groceries, meats, and ready-to-eat food. They highlight the reasonable prices and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e57e-7579-99ce-5340c9cdbced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e57e-7579-99ce-5340c9cdbced",
        "storage_key": "property/6767906449167037/019cfb50-e57e-7579-99ce-5340c9cdbced.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/amarillo/2530-s-georgia-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028910684191050097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "35.1862872",
      "poi_longitude": "-101.8681069",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-468-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c226-763b-9ac4-04678765ce67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c226-763b-9ac4-04678765ce67",
        "storage_key": "property/6767906449167037/019cfb50-c226-763b-9ac4-04678765ce67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_27QvMdPAYcRccmrq1chct4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3fb7f7ed-9666-4c39-bb76-16aaa18ed702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of clothes for all occasions. They also highlight the great deals and cheap prices, and the friendly and helpful staff.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e5aa-7687-b1f3-4db8380722d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e5aa-7687-b1f3-4db8380722d7",
        "storage_key": "property/6767906449167037/019cfb50-e5aa-7687-b1f3-4db8380722d7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16582175913080698917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.1797012",
      "poi_longitude": "-101.940193",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-355-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c26b-708b-a448-3b0c9a8c506a",
        "storage_key": "property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRJbg2BiO5H-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ee7faf08-569a-4fac-9854-74d7e72912e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo College",
      "poi_type": "Education",
      "poi_address": "2201 S Washington St #2411, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-a546-72bc-ab89-e61807184e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a546-72bc-ab89-e61807184e24",
        "storage_key": "property/6767906449167037/019cfb50-a546-72bc-ab89-e61807184e24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362103176866188035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college",
      "poi_latitude": "35.1877711",
      "poi_longitude": "-101.8482546",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c249-77cf-afe2-3088fc2c0d92",
        "storage_key": "property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhTxRNyhOAYcRA0vWlVcDj6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5b3bc846-ea8b-4493-8163-2e5f53c3a313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo College West Campus",
      "poi_type": "Education",
      "poi_address": "6222 SW 9th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e754-71ac-8dc0-75f3b8badfff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e754-71ac-8dc0-75f3b8badfff",
        "storage_key": "property/6767906449167037/019cfb50-e754-71ac-8dc0-75f3b8badfff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7615385847900468607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college-west-campus",
      "poi_latitude": "35.2068369",
      "poi_longitude": "-101.9072632",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c249-77cf-afe2-3088fc2c0d92",
        "storage_key": "property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxkyGsZRAYcRf_WkoxRJr2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7665a6d9-901e-43b3-8f9f-46f256ec428f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Don Harrington Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1200 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Permanent exhibits on the universe & weather, plus a theater & visiting shows for toddlers to teens.",
      "poi_long_description": "People say this science museum offers a wide variety of fun and engaging activities for kids and adults of all ages. They also highlight the immersive learning experiences, the well-organized summer camp program, and the friendly and caring staff.\n\nSome reviews mention the admission price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-a842-76b3-aec9-eec406ae34bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a842-76b3-aec9-eec406ae34bc",
        "storage_key": "property/6767906449167037/019cfb50-a842-76b3-aec9-eec406ae34bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://discoverycenteramarillo.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=551b89ca-129c-4559-8dfb-452b2909f411",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217897852746957318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-harrington-discovery-center",
      "poi_latitude": "35.2000385",
      "poi_longitude": "-101.9132754",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-355-9547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c53b-75df-a05c-54a5f9f0fb4d",
        "storage_key": "property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwVFCrZRAYcRBoJhzhBob7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_750c086c-c88b-4de6-a381-9567b7e1cfdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Bill's Backyard Classics",
      "poi_type": "Entertainment",
      "poi_address": "5309 S Washington St, Amarillo, TX 79110, USA",
      "poi_short_description": "Sizable classic car museum featuring an array of makes & models dating back to the 1920s.",
      "poi_long_description": "People say this museum has an incredible collection of classic cars, lovingly restored and maintained in excellent condition. They highlight the vehicles are driveable and the tour guides are knowledgeable and engaging. They also like the personal tours and the informative walk-throughs of the cars and the history of the collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e976-7619-9232-b2e22dc74bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e976-7619-9232-b2e22dc74bea",
        "storage_key": "property/6767906449167037/019cfb50-e976-7619-9232-b2e22dc74bea.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://www.billsbackyardclassics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8333570560278974626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bills-backyard-classics",
      "poi_latitude": "35.154351",
      "poi_longitude": "-101.8477999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-373-8194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c53b-75df-a05c-54a5f9f0fb4d",
        "storage_key": "property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0Rzl35FAYcRotAUfEXKpnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f7cb5e58-d1a0-4bde-9526-6b87c8148727",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7701 I-40 700, Amarillo, TX 79121, USA",
      "poi_short_description": "Indoor trampoline park providing obstacle courses, a climbing wall, a zipline and more.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, a zipline, and a rock climbing wall, and is a great place for birthday parties. They highlight the fun and playful atmosphere, and the good value, especially with a membership. They also like the helpful, patient, and sweet staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e935-7471-b183-fb09fa36ed78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e935-7471-b183-fb09fa36ed78",
        "storage_key": "property/6767906449167037/019cfb50-e935-7471-b183-fb09fa36ed78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-amarillo/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17183422137472855803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.183417",
      "poi_longitude": "-101.9299011",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-310-9302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2NezVRRAYcR-y6ncWTHd-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_09ae71d6-dac4-42ec-b3c0-852438a7a14f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2200 S Van Buren St, Amarillo, TX 79109, USA",
      "poi_short_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_long_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-a923-77fc-8397-a73578c99089.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a923-77fc-8397-a73578c99089",
        "storage_key": "property/6767906449167037/019cfb50-a923-77fc-8397-a73578c99089.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amoa.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=216dd4bc-81fb-4580-9828-ab80d0de8de8",
      "poi_directions_map_url": "https://maps.google.com/?cid=15566548492245588692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-museum-of-art",
      "poi_latitude": "35.1885361",
      "poi_longitude": "-101.8451167",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-371-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c53b-75df-a05c-54a5f9f0fb4d",
        "storage_key": "property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehFk6dPAYcR1Now62B9B9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fbf0fead-400f-4624-81ab-c4111e26b446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Santa Fe Building",
      "poi_type": "Entertainment",
      "poi_address": "900 S Polk St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-e9e8-74bb-8289-36275043f471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e9e8-74bb-8289-36275043f471",
        "storage_key": "property/6767906449167037/019cfb50-e9e8-74bb-8289-36275043f471.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://downtowntx.org/amarillo-texas/900-s-polk-st-amarillo-tx-79101",
      "poi_directions_map_url": "https://maps.google.com/?cid=14478036840879764717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-building",
      "poi_latitude": "35.204334",
      "poi_longitude": "-101.838079",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-342-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8Pef5OAYcR7TSogcxR7Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_faf83581-baba-4d01-9880-42f85b5ba13b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3801 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean 24/7 gym featuring treadmills, plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good workout experience and has a clean environment. They also highlight the friendly and helpful staff, and the convenient location.\n\nSome reviews mention the equipment can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ea37-74d9-9151-6fe9a3c5e9f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ea37-74d9-9151-6fe9a3c5e9f9",
        "storage_key": "property/6767906449167037/019cfb50-ea37-74d9-9151-6fe9a3c5e9f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/amarillo-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977894688478342336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.1847141",
      "poi_longitude": "-101.8828415",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-358-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaJ0MNpPAYcRwCziZb3kchs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_88d44686-aad1-4fbb-afc3-e37b8ad7b95d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Crunch Fitness - Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain fitness center offering group classes and personal training, plus tanning and a daycare.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including free weights, assisted weights, and Olympic platforms, and that the barbells are strong. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ea7e-7503-b2c1-1c3bc36df9f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ea7e-7503-b2c1-1c3bc36df9f2",
        "storage_key": "property/6767906449167037/019cfb50-ea7e-7503-b2c1-1c3bc36df9f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337674825006290011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---amarillo",
      "poi_latitude": "35.1919693",
      "poi_longitude": "-101.867029",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-358-0706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ429cxMlPAYcRW5QLH_k6E0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d6f18a36-658e-4d90-ba7d-6f6fcdacbdf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - I40/Bell St.",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Bell St, Amarillo, TX 79106, USA",
      "poi_short_description": "Gym chain featuring premium facilities such as basketball courts and saunas, plus personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, pin machines, plate-loaded machines, and functional equipment, as well as a sauna and basketball courts. They highlight the spacious layout, clean facilities, and friendly, helpful staff. They also like the positive and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ebb4-75da-9901-8ad0980c3ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ebb4-75da-9901-8ad0980c3ecf",
        "storage_key": "property/6767906449167037/019cfb50-ebb4-75da-9901-8ad0980c3ecf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/amarillo/hwy-40-bell-st/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17282652066854458207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---i40bell-st",
      "poi_latitude": "35.1889247",
      "poi_longitude": "-101.9037135",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-803-2302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUXZW6JRAYcRX9OHxXxQ2O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c9722fca-a752-4ffb-990d-3485418fe28b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Town Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5801, 4514 Cornell St A, Amarillo, TX 79109, USA",
      "poi_short_description": "Health club offering a variety of equipment and classes, along with indoor and outdoor pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ea71-72bb-974a-ed78bb205ba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ea71-72bb-974a-ed78bb205ba7",
        "storage_key": "property/6767906449167037/019cfb50-ea71-72bb-974a-ed78bb205ba7.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://townclubtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16997861687070698109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "town-club",
      "poi_latitude": "35.16022100000001",
      "poi_longitude": "-101.89843",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-468-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT76sAVQAYcRfSoSVyWJ5Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac59ea86-28cd-48eb-9eeb-aed208bad020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "P.E.T.S. Clinic of Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-eb9a-70d9-8984-c4e946e4b06a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-eb9a-70d9-8984-c4e946e4b06a",
        "storage_key": "property/6767906449167037/019cfb50-eb9a-70d9-8984-c4e946e4b06a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsclinic.org/locations/amarillo-texas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242055613026336119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pets-clinic-of-amarillo",
      "poi_latitude": "35.2117343",
      "poi_longitude": "-101.8647921",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-680-7049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyRWFUtPAYcRd_221f-qPBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b4f70b2f-2a64-443c-b113-1f3ec802a1a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Bnails Amarillo ( Voted Best Nail Salon Amarillo TX)",
      "poi_type": "Health and Wellness",
      "poi_address": "5901 Coulter St S #200, Amarillo, TX 79119, USA",
      "poi_short_description": "Modern nail salon offering a variety of treatments including pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ebe4-77bd-a56d-b5f7b83b53f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ebe4-77bd-a56d-b5f7b83b53f4",
        "storage_key": "property/6767906449167037/019cfb50-ebe4-77bd-a56d-b5f7b83b53f4.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://bnails.com/locations/bnails-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=2463208448936350150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bnails-amarillo--voted-best-nail-salon-amarillo-tx",
      "poi_latitude": "35.1476278",
      "poi_longitude": "-101.9194274",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-329-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbhOxQdbAYcRxpGXnggTLyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_2758ad34-1243-4720-9e97-feeb4b55d3bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "The Gym @ Contagion Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "8210 W Amarillo Blvd Suite A, Amarillo, TX 79124, USA",
      "poi_short_description": "Clean gym with modern equipment, turf, private rooms, a cafe, and friendly staff.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of high-quality equipment, including power racks, deadlift platforms, and machines, as well as a cafe, track, and field. They also highlight the friendly and helpful staff, the clean facility, and the supportive community atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ed99-70a9-ad1e-6717b1b1b04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ed99-70a9-ad1e-6717b1b1b04a",
        "storage_key": "property/6767906449167037/019cfb50-ed99-70a9-ad1e-6717b1b1b04a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://contagionathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028127880143985371&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-gym--contagion-athletics",
      "poi_latitude": "35.1921768",
      "poi_longitude": "-101.9283828",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-599-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVPdCchaAYcR21qoF9ykRA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0ec52f0-2f2f-4bae-b5d5-ecc4b9edfe2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Small Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "5127 Canyon Dr, Amarillo, TX 79110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ede6-702f-97c7-796a71d9b29a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ede6-702f-97c7-796a71d9b29a",
        "storage_key": "property/6767906449167037/019cfb50-ede6-702f-97c7-796a71d9b29a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.smallanimalec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3409723369463033888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "small-animal-emergency-clinic",
      "poi_latitude": "35.156026",
      "poi_longitude": "-101.877585",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-352-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQR8CU5FAYcRIDAxy1bFUS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_beb87303-75c0-462d-b7ae-afea1660df13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4514 First United Dr, Amarillo, TX 79119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ef32-769a-9dda-6af9f800a57d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ef32-769a-9dda-6af9f800a57d",
        "storage_key": "property/6767906449167037/019cfb50-ef32-769a-9dda-6af9f800a57d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/amarillo-texas-4451/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4451",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329623978590993559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.1605005",
      "poi_longitude": "-101.9368164",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-367-9842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwTg_UNRAYcRl_ztthHqFTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_563f8e17-3d58-4722-aae0-c7fb287b8d73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Animal Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6201 W Amarillo Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ee03-778b-b9cc-c131032fff0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ee03-778b-b9cc-c131032fff0c",
        "storage_key": "property/6767906449167037/019cfb50-ee03-778b-b9cc-c131032fff0c.webp",
        "width": 659,
        "height": 1000
      },
      "poi_business_url": "https://www.myanimalmedicalcenter.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTI4NzExMDMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9402121048239326052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-medical-center",
      "poi_latitude": "35.199878",
      "poi_longitude": "-101.9080634",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-358-7831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-E_w8tRAYcRZEOHX0cLe4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_94989a56-5fac-4284-9d77-c08b75542554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "BSA Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-b8ee-72a3-a97a-c7e25fcaecc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b8ee-72a3-a97a-c7e25fcaecc9",
        "storage_key": "property/6767906449167037/019cfb50-b8ee-72a3-a97a-c7e25fcaecc9.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://bsahs.org/find-a-provider/location/entity69860/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8155463932870903813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bsa-hospital",
      "poi_latitude": "35.1982302",
      "poi_longitude": "-101.9214119",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c55f-705b-95bf-f818cdf2f5e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c55f-705b-95bf-f818cdf2f5e4",
        "storage_key": "property/6767906449167037/019cfb50-c55f-705b-95bf-f818cdf2f5e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-hXBuxRAYcRBchHyTwHLnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b8775db1-af99-4061-877b-989944c91fc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Northwest Texas Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ab00-713a-ab58-7a703272384b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ab00-713a-ab58-7a703272384b",
        "storage_key": "property/6767906449167037/019cfb50-ab00-713a-ab58-7a703272384b.webp",
        "width": 724,
        "height": 407
      },
      "poi_business_url": "https://www.nwths.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075520162708353978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwest-texas-healthcare-system",
      "poi_latitude": "35.1998268",
      "poi_longitude": "-101.9201891",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-354-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c55f-705b-95bf-f818cdf2f5e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c55f-705b-95bf-f818cdf2f5e4",
        "storage_key": "property/6767906449167037/019cfb50-c55f-705b-95bf-f818cdf2f5e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO08CY7FRAYcRunNkZpe6zRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2cf48328-97f9-49b2-80fa-36b491cadc06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Native flora are showcased over 4 acres of seasonal gardens, with an indoor tropical conservatory.",
      "poi_long_description": "People say this botanical garden offers beautiful plants, flowers, and gardens, including a Japanese garden and a koi pond. They highlight the peaceful and tranquil atmosphere, and the well-maintained grounds. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-ef84-721e-b7ec-6175a46c214d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ef84-721e-b7ec-6175a46c214d",
        "storage_key": "property/6767906449167037/019cfb50-ef84-721e-b7ec-6175a46c214d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amarillobotanicalgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051265959285629208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-botanical-gardens",
      "poi_latitude": "35.197691",
      "poi_longitude": "-101.915258",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-352-6513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYUtV7RRAYcRGCGWfdb7XZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_046dfb90-4dd2-4e5a-8293-0271f5340c73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "John Stiff Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 Bell St, Amarillo, TX 79109, USA",
      "poi_short_description": "Large open space, mainly for organized sports, featuring soccer and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-b34c-760b-b007-23a9bd2063f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b34c-760b-b007-23a9bd2063f3",
        "storage_key": "property/6767906449167037/019cfb50-b34c-760b-b007-23a9bd2063f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/john-stiff-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14142316035318156834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-stiff-memorial-park",
      "poi_latitude": "35.1534565",
      "poi_longitude": "-101.9061596",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5FNyghQAYcRIg5zQoGZQ8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_366f6466-543e-4c19-9dd2-5934a1691ceb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Wildcat Bluff Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 N Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Preserve with miles of hiking trails and historical exhibits including a dig pit, plus picnic areas.",
      "poi_long_description": "Visitors say this nature preserve offers several easy hiking trails, a large playground, and a wildlife center with local animals. They also highlight the beautiful wildflowers, diverse terrain, and well-maintained trails, making it a great spot for families with kids and grandparents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-a9f3-722e-81d0-9da3ca0265ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a9f3-722e-81d0-9da3ca0265ec",
        "storage_key": "property/6767906449167037/019cfb50-a9f3-722e-81d0-9da3ca0265ec.webp",
        "width": 1125,
        "height": 633
      },
      "poi_business_url": "http://wildcatbluff.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=ff955b2f-0847-4125-bf3c-98fd107de872",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448519830726704444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-bluff-nature-center",
      "poi_latitude": "35.2351151",
      "poi_longitude": "-101.9398872",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-352-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnY_PHH5RAYcRPP2SiBwtGhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8e8878d4-952f-46ce-bbcf-27033d586d03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2501 S Washington St, Amarillo, TX 79109, USA",
      "poi_short_description": "Rose-filled park featuring playground equipment, basketball courts, tennis courts and a splash pad.",
      "poi_long_description": "People say this city park offers pickleball courts, tennis courts, and a splash pad. They highlight the park is clean, well-maintained, and family-friendly. They also like the ample shade and convenient location near the highway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-b528-762d-9b43-74540f0a447c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b528-762d-9b43-74540f0a447c",
        "storage_key": "property/6767906449167037/019cfb50-b528-762d-9b43-74540f0a447c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://amarilloparks.org/parks-facilities/parks/memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6032325091350410499&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "35.1856121",
      "poi_longitude": "-101.8473415",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDT5IzKZPAYcRA_Wdv7Uft1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aec5de17-d113-45c1-a36f-ec736dc7074f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Medical Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "Traditional waterside park offering a children's playground, splash pad, ducks & picnic tables.",
      "poi_long_description": "People say this park offers a splash pad, walking trails, basketball court, lake, trees, picnic tables, and a playground. They highlight the park is a nice place to visit for a walk and to play with children, and that it's enjoyable for people of all ages. They also like the fishing opportunities and bird watching. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-f07d-7059-b5ea-89b6f3c1f99d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-f07d-7059-b5ea-89b6f3c1f99d",
        "storage_key": "property/6767906449167037/019cfb50-f07d-7059-b5ea-89b6f3c1f99d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amarilloparks.org/parks-facilities/parks/medical-center-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9095130730762279602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medical-center-park",
      "poi_latitude": "35.2009597",
      "poi_longitude": "-101.9136857",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzHNYLZRAYcRshrTKDZlOH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_94e45375-aabe-4dca-934f-948d4ef695e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Tradewind Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4105 Tradewind St, Amarillo, TX 79118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-f12d-714a-9ae9-a23e28e52951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-f12d-714a-9ae9-a23e28e52951",
        "storage_key": "property/6767906449167037/019cfb50-f12d-714a-9ae9-a23e28e52951.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tradewindairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15990282243124226512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tradewind-airport",
      "poi_latitude": "35.168991",
      "poi_longitude": "-101.828453",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-376-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c55f-705b-95bf-fe17b493d13b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c55f-705b-95bf-fe17b493d13b",
        "storage_key": "property/6767906449167037/019cfb50-c55f-705b-95bf-fe17b493d13b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yXpyPFOAYcR0Omn3_rk6N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8d6294d7-9623-4adc-9c3d-a931334d5dc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Panhandle Eye Group Corporate Business Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7400 Fleming Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-f210-730f-a34a-b040fe1c5dfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-f210-730f-a34a-b040fe1c5dfa",
        "storage_key": "property/6767906449167037/019cfb50-f210-730f-a34a-b040fe1c5dfa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paneye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6239967148491259387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-eye-group-corporate-business-office",
      "poi_latitude": "35.1935734",
      "poi_longitude": "-101.9237593",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-331-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcUlU61RAYcR-73tjw_RmFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fa503b69-ab43-4c3c-be8a-8dbd8f318203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Toot'n Totum Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S Taylor St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tootntotum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938605481419247298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tootn-totum-corporate-office",
      "poi_latitude": "35.2019996",
      "poi_longitude": "-101.8364486",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-373-4351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWigFwJPAYcRwo6-QgcF7Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bab1399a-3acd-4461-8f2c-2ac21d7ddbfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Downtown Women's Center - Admin Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "409 S Monroe St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.dwcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17471674227271005040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-womens-center---admin-office",
      "poi_latitude": "35.2100297",
      "poi_longitude": "-101.8426996",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-372-3625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-D7mlVOAYcRcPPVCyTbd_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3d9fa70f-344e-41f9-b833-443052861095",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Panhandle AIDS Support Organization",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 SW 10th Ave, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-f234-7121-9072-43c3fdf245a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-f234-7121-9072-43c3fdf245a0",
        "storage_key": "property/6767906449167037/019cfb50-f234-7121-9072-43c3fdf245a0.webp",
        "width": 1280,
        "height": 892
      },
      "poi_business_url": "http://panhandleaso.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7593567755602905026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-aids-support-organization",
      "poi_latitude": "35.2048277",
      "poi_longitude": "-101.8548318",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-372-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxRxZalPAYcRwkeSKqTFYWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cdc4d928-dd76-40b9-8bd8-346d788ee109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Full Smile Management",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 Civic Cir Suite 600, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fullsmilemanagement.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167356463195991801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "full-smile-management",
      "poi_latitude": "35.1906971",
      "poi_longitude": "-101.8643049",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-381-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVO_ZDdRAYcR-a4t7iH-OH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7055cc3b-96a1-4270-84f3-635c6502666e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Pantex Plant",
      "poi_type": "Education",
      "poi_address": "US Highway 60 & FM2373, Panhandle, TX 79068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2286-7734-a551-20d0854209b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2286-7734-a551-20d0854209b6",
        "storage_key": "property/6767906449167037/019d7917-2286-7734-a551-20d0854209b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pantex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3804094491705127665&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pantex-plant",
      "poi_latitude": "35.3090458",
      "poi_longitude": "-101.5581457",
      "poi_miles_from_property": "29.1 mi",
      "poi_walking_minutes": "10 hours 37 mins",
      "poi_biking_minutes": "2 hours 30 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 806-477-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c569-77aa-9b5e-643cebba5a50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c569-77aa-9b5e-643cebba5a50",
        "storage_key": "property/6767906449167037/019cfb50-c569-77aa-9b5e-643cebba5a50.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ToTc6s2AYcR8bIaBsnbyjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_4607d579-79a9-4750-85e1-9770110e6e73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Texas Tech Physicians: Family Medicine",
      "poi_type": "Education",
      "poi_address": "1400 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2301-72ef-a0a8-3e262ebc259b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2301-72ef-a0a8-3e262ebc259b",
        "storage_key": "property/6767906449167037/019d7917-2301-72ef-a0a8-3e262ebc259b.webp",
        "width": 960,
        "height": 539
      },
      "poi_business_url": "https://texastechphysicians.com/clinics/amarillo/family-medicine.aspx?utm_source=GMBSocialClimb&utm_medium=TexasTechPhysicians%3AFamilyMedicine",
      "poi_directions_map_url": "https://maps.google.com/?cid=10586427086975373676&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-tech-physicians-family-medicine",
      "poi_latitude": "35.2003873",
      "poi_longitude": "-101.9243312",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-414-9559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0b0fIq5RAYcRbJG9p1iL6pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_bdd13744-8b8f-4555-b008-c61fa65ef791",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo Independent School District",
      "poi_type": "Education",
      "poi_address": "Amarillo Independent School District, TX, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18091657211138340326&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-independent-school-district",
      "poi_latitude": "35.2015494",
      "poi_longitude": "-101.8435568",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU8qbI1ROAYcR5vUIPGF6Evs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d95eb7bf-fc5c-47f9-a765-d909dfd9e1be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Tyson Foods",
      "poi_type": "Education",
      "poi_address": "5000 FM1912, Amarillo, TX 79108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-28c6-701f-8a22-3436ea7b5cba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-28c6-701f-8a22-3436ea7b5cba",
        "storage_key": "property/6767906449167037/019d7917-28c6-701f-8a22-3436ea7b5cba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tysonfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6231956934192628239&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tyson-foods",
      "poi_latitude": "35.2583166",
      "poi_longitude": "-101.6496981",
      "poi_miles_from_property": "20.4 mi",
      "poi_walking_minutes": "7 hours 29 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 806-335-1531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XgChoU2AYcRD4IVNtBbfFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d89ee26a-4f07-4411-a08c-573a3e3feecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Bell Textron Inc.",
      "poi_type": "Education",
      "poi_address": "10201 Airport Blvd # 181, Amarillo, TX 79111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2187-749f-86f5-bbe61e48cac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2187-749f-86f5-bbe61e48cac1",
        "storage_key": "property/6767906449167037/019d7917-2187-749f-86f5-bbe61e48cac1.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.bellhelicopter.textron.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3380312967847534742&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bell-textron-inc",
      "poi_latitude": "35.2100583",
      "poi_longitude": "-101.7134622",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 806-341-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVUTEixIAYcRluAyDrxI6S4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_61947e64-21be-49e8-a4ab-f97dcf4ba98a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Baptist St Anthony Health System: Barkley Brian F MD",
      "poi_type": "Education",
      "poi_address": "1600 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bsahs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9085633568160380598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "baptist-st-anthony-health-system-barkley-brian-f-md",
      "poi_latitude": "35.1950848",
      "poi_longitude": "-101.9199004",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaefDLNRAYcRtnaQrZenFn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_577752e3-8dbb-429b-9a4e-b780bb944850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Northwest Texas Healthcare System Behavioral Health",
      "poi_type": "Education",
      "poi_address": "1501 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2ac3-73b9-a431-521166758229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2ac3-73b9-a431-521166758229",
        "storage_key": "property/6767906449167037/019d7917-2ac3-73b9-a431-521166758229.webp",
        "width": 992,
        "height": 1280
      },
      "poi_business_url": "https://nwthsbehavioralhealth.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14391069874621105956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwest-texas-healthcare-system-behavioral-health",
      "poi_latitude": "35.1996443",
      "poi_longitude": "-101.9201744",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-354-1810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfhOd7FRAYcRJMedxs1Zt8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_106bc002-f446-41d5-8d9f-aee8bdf62841",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Canyon Independent School District",
      "poi_type": "Education",
      "poi_address": "6407 Lair Rd, Amarillo, TX 79118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5856000394172319246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "canyon-independent-school-district",
      "poi_latitude": "35.0570008",
      "poi_longitude": "-101.9089776",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-656-6140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c249-77cf-afe2-3088fc2c0d92",
        "storage_key": "property/6767906449167037/019cfb50-c249-77cf-afe2-3088fc2c0d92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUYaiB6NcAYcRDkYwA1WxRFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_45ab7b69-78a4-4a41-a54d-16c68324d0fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Teddy Jack's Armadillo Grill",
      "poi_type": "Restaurants",
      "poi_address": "5080 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Family-friendly grill serving burgers and Tex-Mex fare, along with beer and cocktails.",
      "poi_long_description": "People say this restaurant offers a wide variety of dishes, including pizza, salads, and burgers. They also highlight the great service and friendly staff.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2b62-738d-9eed-3b9b438a4431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2b62-738d-9eed-3b9b438a4431",
        "storage_key": "property/6767906449167037/019d7917-2b62-738d-9eed-3b9b438a4431.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://teddyjacks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5472714489992181899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teddy-jack-s-armadillo-grill",
      "poi_latitude": "35.1540453",
      "poi_longitude": "-101.9207991",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-322-0113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYW9a-XZQAYcRi_gdPdX88ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_351548fa-e484-447a-9754-4ecf58b9069e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Torchy's Tacos",
      "poi_type": "Restaurants",
      "poi_address": "3562 S Soncy Rd Ste. 101, Amarillo, TX 79119, USA",
      "poi_short_description": "Local chain serving Mexican-street-food-style tacos in inventive varieties, including for breakfast.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, queso, and burritos. They also highlight the fun atmosphere, friendly staff, and quick service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-2e63-74fe-a6c9-db8dc87abd67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2e63-74fe-a6c9-db8dc87abd67",
        "storage_key": "property/6767906449167037/019d7917-2e63-74fe-a6c9-db8dc87abd67.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://torchystacos.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=16388641799719380111&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "torchy-s-tacos",
      "poi_latitude": "35.1702372",
      "poi_longitude": "-101.9394222",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-398-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yXSSfRQAYcRj2Rk1-ImcOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d9cd1268-6d45-4541-8e7d-89d543001c94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Blue Sky",
      "poi_type": "Restaurants",
      "poi_address": "5060 Coulter St S, Amarillo, TX 79119, USA",
      "poi_short_description": "Burgers, chicken fried steak, and other comfort fare served in a relaxed setting.",
      "poi_long_description": "People say this hamburger restaurant serves good burgers, fries, and onion rings. They highlight the reasonable prices, fast meal prep, and nice atmosphere. They also like the friendly customer service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-3510-7280-8998-6702e3a6dcce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3510-7280-8998-6702e3a6dcce",
        "storage_key": "property/6767906449167037/019d7917-3510-7280-8998-6702e3a6dcce.webp",
        "width": 1280,
        "height": 691
      },
      "poi_business_url": "http://www.blueskytexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14213884522077634494&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-sky",
      "poi_latitude": "35.1546028",
      "poi_longitude": "-101.9210233",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-322-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxdBO-XZQAYcRvj_cGKrcQcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_a38f420a-5407-45bb-aa41-e45bda085822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "575 Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "7710 Hillside Rd #700, Amarillo, TX 79119, USA",
      "poi_short_description": "Laid-back restaurant pizza joint specializing in pies with craft beer options plus salads and desserts such as cannoli.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a variety of toppings, including vegan options, and a selection of craft beers. They highlight the fresh ingredients, crispy crust, and flavorful toppings, as well as the casual and welcoming atmosphere. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-3ccd-773b-a261-7f0e53e2b163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3ccd-773b-a261-7f0e53e2b163",
        "storage_key": "property/6767906449167037/019d7917-3ccd-773b-a261-7f0e53e2b163.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://575pizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9250775078454968272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "575-pizzeria",
      "poi_latitude": "35.1475174",
      "poi_longitude": "-101.925514",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 806-322-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNS_X4oJaAYcR0D9Y0OtaYYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_24f7940e-1c1b-4447-8de0-78c7512966c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Cafe Marizon",
      "poi_type": "Restaurants",
      "poi_address": "6151 Hillside Rd, Amarillo, TX 79109, USA",
      "poi_short_description": "American fare in a spacious dining room lined with local historical photos, plus an outdoor patio.",
      "poi_long_description": "People say this restaurant serves delicious, home-style American comfort food, including roast beef, chicken fried chicken, and hamburger steak. They highlight the fair prices, casual and nostalgic vibe, and the friendly and attentive staff. They also like the homemade bread and ranch dressing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-3906-72a7-a0c7-86cc2ea808b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3906-72a7-a0c7-86cc2ea808b1",
        "storage_key": "property/6767906449167037/019d7917-3906-72a7-a0c7-86cc2ea808b1.webp",
        "width": 1280,
        "height": 734
      },
      "poi_business_url": "https://www.cafemarizon.com/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=5753728732827268520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-marizon",
      "poi_latitude": "35.1462424",
      "poi_longitude": "-101.9042858",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-352-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVwoFvxOAYcRqLUgRsxZ2U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8869a3d9-8af7-4eea-a85d-d3646d07e0ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "8300 I-40 W, Amarillo, TX 79106, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "People say this steakhouse serves delicious ribeye and filet steaks, as well as ribs and cheesecake. They also highlight the friendly and attentive service, and the casual, western atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-3a3f-70e4-9010-2d6201e52385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3a3f-70e4-9010-2d6201e52385",
        "storage_key": "property/6767906449167037/019d7917-3a3f-70e4-9010-2d6201e52385.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-amarillo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16880214763672980536&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "35.1880581",
      "poi_longitude": "-101.93304",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-351-0349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQdU21VQAYcROEwIceSRQuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_70d9613d-519c-478a-b9b6-44c01459c188",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Tyler's Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "3301 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Down-home BBQ place in a little red house, serving dry-rub ribs smoked daily, plus brisket & sides.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and pulled pork. They highlight the tender, juicy, and flavorful meat, as well as the excellent rub on the ribs and the tasty sides. They also like the reasonable prices and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-4905-7418-863f-dba18184c06f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4905-7418-863f-dba18184c06f",
        "storage_key": "property/6767906449167037/019d7917-4905-7418-863f-dba18184c06f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tylersbarbeque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13029359707188135794&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tyler-s-barbeque",
      "poi_latitude": "35.1842241",
      "poi_longitude": "-101.8760089",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-331-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c230-707f-b62c-5becc5e50d46",
        "storage_key": "property/6767906449167037/019cfb50-c230-707f-b62c-5becc5e50d46.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-l84c5PAYcRcoe8BZ-V0bQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_ba57a073-f486-46c0-8aa0-1cb108205b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Restaurants",
      "poi_address": "8201 I-40 W, Amarillo, TX 79121, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of items, including seasonal items, gifts, and household goods, at great prices. They also highlight the friendly and helpful staff, and many appreciate the convenient curbside pickup service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-4dd6-7548-a35a-7018f4e2ad6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4dd6-7548-a35a-7018f4e2ad6d",
        "storage_key": "property/6767906449167037/019d7917-4dd6-7548-a35a-7018f4e2ad6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/amarillo/221",
      "poi_directions_map_url": "https://maps.google.com/?cid=2462063419515012103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.1859504",
      "poi_longitude": "-101.934272",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c26b-708b-a448-3b0c9a8c506a",
        "storage_key": "property/6767906449167037/019cfb50-c26b-708b-a448-3b0c9a8c506a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ5MuplBQAYcRBwStrqIBKyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_00860b99-c788-4daf-b0d6-e324c15b9a16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Cinergy Amarillo Featuring EPIC",
      "poi_type": "Entertainment",
      "poi_address": "9201 Cinergy Sq, Amarillo, TX 79119, USA",
      "poi_short_description": "Multi-attraction entertainment destination featuring movie theaters, an arcade, laser tag and escape rooms.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats, a wide variety of games, and good food and drinks. They highlight the fun and entertaining atmosphere, and the friendly and helpful staff. They also like the convenient option to order food and drinks from their seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-a568-7018-9554-d8019ac8bd02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a568-7018-9554-d8019ac8bd02",
        "storage_key": "property/6767906449167037/019cfb50-a568-7018-9554-d8019ac8bd02.webp",
        "width": 1280,
        "height": 389
      },
      "poi_business_url": "https://www.cinergy.com/amarillo?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=10917071146808263484&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinergy-amarillo-featuring-epic",
      "poi_latitude": "35.1529465",
      "poi_longitude": "-101.9445709",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-414-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c267-725b-bff5-acaa43fb9808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c267-725b-bff5-acaa43fb9808",
        "storage_key": "property/6767906449167037/019cfb50-c267-725b-bff5-acaa43fb9808.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5enBHVRAYcRPEMs7V06gZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_70997e50-54c7-497f-b005-6f257c98f57d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "John Stiff Memorial Park",
      "poi_type": "Entertainment",
      "poi_address": "McDonald Lake, Amarillo, TX 79109, USA",
      "poi_short_description": "Relaxed park with a baseball diamond, skateboard park and a lake, plus playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-5146-7115-8781-d8e878d41e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5146-7115-8781-d8e878d41e6a",
        "storage_key": "property/6767906449167037/019d7917-5146-7115-8781-d8e878d41e6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051785386314455301&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-stiff-memorial-park",
      "poi_latitude": "35.1573007",
      "poi_longitude": "-101.9168418",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0Yj73NQAYcRBVkgBUHUX5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f29448a-7ccb-428a-82be-3040284ab1e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "McDonald Lake",
      "poi_type": "Entertainment",
      "poi_address": "McDonald Lake, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-554e-76d3-9406-ef5319407794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-554e-76d3-9406-ef5319407794",
        "storage_key": "property/6767906449167037/019d7917-554e-76d3-9406-ef5319407794.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5198101153194065271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcdonald-lake",
      "poi_latitude": "35.1583714",
      "poi_longitude": "-101.9169785",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1se1XNQAYcRdz2uRnVdI0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_f2b8d143-281c-4972-9ade-c9eb99a58d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Cinemark Amarillo Hollywood 16 and XD",
      "poi_type": "Entertainment",
      "poi_address": "9100 Canyon Dr, Amarillo, TX 79119, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a wide selection of movies. They highlight the convenient online ticket purchasing and the clean theaters and seats. They also like the friendly and polite staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-5425-7287-b2f8-3fe4cae472ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5425-7287-b2f8-3fe4cae472ac",
        "storage_key": "property/6767906449167037/019d7917-5425-7287-b2f8-3fe4cae472ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-amarillo/cinemark-amarillo-hollywood-16-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7987522426007570925&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-amarillo-hollywood-16-and-xd",
      "poi_latitude": "35.114079",
      "poi_longitude": "-101.9125817",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-352-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c267-725b-bff5-acaa43fb9808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c267-725b-bff5-acaa43fb9808",
        "storage_key": "property/6767906449167037/019cfb50-c267-725b-bff5-acaa43fb9808.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaMuCt5aAYcR7cmlpVNh2W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_eb367f43-9862-4eaa-8bc9-d9355e6e708d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Cadillac Ranch",
      "poi_type": "Entertainment",
      "poi_address": "13651 I-40 Frontage Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Quirky public art installation featuring half-buried vintage Cadillacs covered with bright graffiti.",
      "poi_long_description": "People say this sculpture is a quirky and colorful art installation featuring painted cars. They also highlight the free entry, the opportunity to spray paint the cars, and the unique photo opportunities.\n\nSome reviews mention the trail can be muddy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-632d-717c-ba7b-e909f304dbb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-632d-717c-ba7b-e909f304dbb6",
        "storage_key": "property/6767906449167037/019d7917-632d-717c-ba7b-e909f304dbb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/1974cadillacranch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6041817576782515537&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cadillac-ranch",
      "poi_latitude": "35.1872366",
      "poi_longitude": "-101.9870486",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 833-330-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8Roa9ZWAYcRUU3VPRPZ2FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sculpture"
    },
    {
      "id": "custom_34550bb9-6d08-4e55-ad27-9d89089f924f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "American Quarter Horse Hall of Fame & Museum",
      "poi_type": "Entertainment",
      "poi_address": "2601 E Interstate Dr, Amarillo, TX 79104, USA",
      "poi_short_description": "Museum with interactive exhibits devoted to this famous horse breed & its history in America.",
      "poi_long_description": "People say this museum offers great exhibits on the horse in cinema, American Quarter Horse history, and the role of horses in settling the West. They highlight the interactive exhibits, the Hall of Fame section, and the beautiful building. They also like the friendly and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-5a50-728c-8e75-70b09ffdfb60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5a50-728c-8e75-70b09ffdfb60",
        "storage_key": "property/6767906449167037/019d7917-5a50-728c-8e75-70b09ffdfb60.webp",
        "width": 850,
        "height": 417
      },
      "poi_business_url": "http://aqha.com/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295682578937935522&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "american-quarter-horse-hall-of-fame-museum",
      "poi_latitude": "35.1942386",
      "poi_longitude": "-101.8079849",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-376-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c53b-75df-a05c-54a5f9f0fb4d",
        "storage_key": "property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbqJ1C9PAYcRovaZv6Z4P2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_229ddcf4-fc70-458c-bcd4-f9d388c3c8c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Palo Duro Canyon State Park",
      "poi_type": "Entertainment",
      "poi_address": "Canyon, TX 79015, USA",
      "poi_short_description": "Big ravine with 800-ft cliffs, multi-use trails, campsites & the musical \"Texas\" in an amphitheater.",
      "poi_long_description": "People say this state park offers stunning views of the canyon, fun hiking and biking trails, and delicious hotdogs at the outpost. They highlight the beautiful scenery, well-maintained trails, and clean restrooms. They also like the convenient amenities, such as sunscreen and water stations, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-62a6-723e-bc15-bf2306ddb46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-62a6-723e-bc15-bf2306ddb46d",
        "storage_key": "property/6767906449167037/019d7917-62a6-723e-bc15-bf2306ddb46d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/palo-duro-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=2130752817766660468&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "palo-duro-canyon-state-park",
      "poi_latitude": "34.9372503",
      "poi_longitude": "-101.6589305",
      "poi_miles_from_property": "29.2 mi",
      "poi_walking_minutes": "10 hours 29 mins",
      "poi_biking_minutes": "2 hours 27 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 806-488-2227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c555-77b9-a381-2cfd3448cd1d",
        "storage_key": "property/6767906449167037/019cfb50-c555-77b9-a381-2cfd3448cd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWSkAmEUAYcRdPkkB2b0kR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_7373b6bb-3069-498c-b51d-81379240ace1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Texas Air & Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "10001 American Dr, Amarillo, TX 79111, USA",
      "poi_short_description": "A variety of aerospace artifacts on display, plus several civilian & military aircraft.",
      "poi_long_description": "People say this museum offers a lot to see and learn, including several planes that visitors can explore. They highlight the knowledgeable and friendly staff, and the fun, hands-on experience. They also like the opportunity to learn the stories behind the exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-618b-764f-896c-ea10ddb5f2c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-618b-764f-896c-ea10ddb5f2c8",
        "storage_key": "property/6767906449167037/019d7917-618b-764f-896c-ea10ddb5f2c8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.texasairandspacemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11398286253293493375&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-air-space-museum",
      "poi_latitude": "35.2134157",
      "poi_longitude": "-101.7140016",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 806-335-9159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c53b-75df-a05c-54a5f9f0fb4d",
        "storage_key": "property/6767906449167037/019cfb50-c53b-75df-a05c-54a5f9f0fb4d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0uctixIAYcRf9zG5_TYLp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_76710bc6-9b93-473c-bbff-545f75e9243b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Amarillo Zoo",
      "poi_type": "Entertainment",
      "poi_address": "700 Comanchero Trail, Amarillo, TX 79107, USA",
      "poi_short_description": "Bison & big cats, reptiles, birds & amphibians all can be found in this compact park.",
      "poi_long_description": "People say this zoo offers a variety of animals, including exotic creatures, and is a fun and affordable experience for families.\n\nOther reviews mention the facilities can be neglected and some enclosures can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d7917-6468-7349-9b95-810f2f270274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6468-7349-9b95-810f2f270274",
        "storage_key": "property/6767906449167037/019d7917-6468-7349-9b95-810f2f270274.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://zoo.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520201244900869847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-zoo",
      "poi_latitude": "35.2394971",
      "poi_longitude": "-101.8352622",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 806-381-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-c23d-745b-adf3-51cb56deb98e",
        "storage_key": "property/6767906449167037/019cfb50-c23d-745b-adf3-51cb56deb98e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-PYbYVOAYcR10bEQTAfXWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_4b730e60-f92f-4917-bebd-cfdd91f94a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "poi_name": "Urbana Coffee Works",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "urbana-coffee-works",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4958fa19fa18998460d90fef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_38ee0dfe583055f3b06d1d9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9535de09e936779fbf174bcc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2178af37e026d5454ce26a32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f1673bf194a95e92fb427ffe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_36dda2e71fffca1deac112ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_70e3accc-fe8c-4e9e-a4c9-91e221c62e24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "rating": "5.0",
      "name": "Josh Davidson",
      "text": "Put in a request before work and it was fixed when I got home from work. Thank you for listening and acting fast, even if it was a small issue like a light. I appreciate you all and thank you very much!",
      "date": "2025-12-10",
      "title": ""
    },
    {
      "id": "custom_f22cfc3a-e7b9-4f1d-a500-cd49d4ae4ba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "rating": "5.0",
      "name": "Tammye Morris",
      "text": "I have lived at The Colonies on Hillside for several years and absolutely love it here. Management and staff are always on top of everything on the property! They keep it in tiptop shape. The maintenance staff is professional and solves any problem or issue in a very timely manner. In my opinion, this is the best apartment home community in Amarillo.",
      "date": "2025-08-28",
      "title": ""
    },
    {
      "id": "custom_ad367fd2-9814-48b8-8981-c9eb4e631358",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "rating": "5.0",
      "name": "CookieCutterCooking",
      "text": "Great, Clean, Quiet and affordable place\nto live, Any Problem in the residence maintenance is out same day fixing the issue . They do property clean up every Friday mowing and cutting down bushes",
      "date": "2025-11-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fbe39b6b-4fd9-425b-9ca8-605fbccde864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb51-0678-72f2-8017-e6a0a00b6c3e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of an outdoor swimming pool and lounge chairs.",
        "public_id": "019cfb51-0678-72f2-8017-e6a0a00b6c3e",
        "storage_key": "property/6767906449167037/019cfb51-0678-72f2-8017-e6a0a00b6c3e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Colonies at Hillside Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d5989ee5aba0c3b8bddf1&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-addc-7089-b83c-bc58451e5461",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-colonies-at-hillside",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037"
    },
    {
      "lead_collector_id": "019cf79d-ae4c-712c-baa2-924807dfe800",
      "lead_source": "LANDING_PAGE",
      "name": "the-colonies-at-hillside",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "pool-apartments-in-amarillo-tx-colonies-hillside",
      "search_query": "pool apartments in Amarillo TX",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Amarillo, TX",
      "h2_subtitle": "Discover premium pool apartments in Amarillo. Dive into luxurious amenities and spacious living at The Colonies at Hillside.",
      "page_copy": "Looking for pool apartments in Amarillo, TX? Welcome to The Colonies at Hillside, where comfort meets style. Our community offers a refreshing way to relax with our top-notch amenities, perfect for those hot Texas days. Spend quality time at our inviting pool area, ideal for unwinding after a long day or socializing with neighbors and friends.\n\nBeyond the pool, The Colonies at Hillside provides a living experience tailored for your needs. Our spacious floor plans and modern kitchens provide the perfect backdrop for your lifestyle. Enjoy the convenience of our Business Center, Cyber Cafe, and seamless online rental payments. Experience all this and more in a community that's designed for you.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Amarillo, TX - The Colonies",
      "seo_description": "Discover pool apartments in Amarillo, TX at The Colonies. Enjoy luxurious amenities and spacious living. Contact us for a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-randall-county-colonies-hillside",
      "search_query": "dog-friendly apartments Randall County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Randall County",
      "h2_subtitle": "Experience premier dog-friendly apartments in Randall County. The Colonies at Hillside welcomes you and your furry friends.",
      "page_copy": "At The Colonies at Hillside, we believe that pets are part of the family. If you're searching for dog-friendly apartments in Randall County, our community is the perfect fit for you and your canine companion. We offer a dedicated Bark Park, where your dog can run freely and enjoy playtime with other pets in the neighborhood.\n\nOur spacious floor plans ensure both you and your pets have plenty of room to live comfortably. Located conveniently on Hillside Rd, our community also features amenities like a fully equipped kitchen and online rental payments, adding ease to your lifestyle. Join The Colonies at Hillside, where pet-friendliness blends seamlessly with modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Randall County",
      "seo_description": "Live at The Colonies in Randall County. Our dog-friendly apartments offer spacious living and a Bark Park. Perfect for pet lovers!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "garage-parking-apartments-hillside-amarillo-colonies",
      "search_query": "garage parking apartments Hillside Amarillo",
      "category": "Amenity",
      "h1_title": "Garage Parking Apartments in Hillside Amarillo",
      "h2_subtitle": "Explore garage parking apartments in Hillside Amarillo. Enjoy the convenience and security of private parking at The Colonies.",
      "page_copy": "Welcome to The Colonies at Hillside, where garage parking is just one of the many features that make our apartments stand out in Amarillo. If you’re seeking the convenience and security of garage parking apartments in Hillside Amarillo, you’ll love our accommodating spaces designed for a hassle-free lifestyle.\n\nBeyond the luxury of secure parking, our community offers a range of amenities that cater to all residents. Enjoy leisure time in our spacious floor plans, make use of the Business Center & Cyber Cafe, or cook a delicious meal in a fully equipped kitchen. With such varied offerings, you'll find everything you need at The Colonies at Hillside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garage Parking Apartments in Hillside Amarillo",
      "seo_description": "Discover garage parking apartments at The Colonies in Hillside Amarillo. Enjoy secure parking and premium amenities. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "modern-apartments-vaulted-ceilings-amarillo-colonies",
      "search_query": "modern apartments with vaulted ceilings Amarillo",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Vaulted Ceilings Amarillo",
      "h2_subtitle": "Find modern apartments with vaulted ceilings in Amarillo. The Colonies at Hillside offers elevated living spaces just for you.",
      "page_copy": "Discover contemporary living at The Colonies at Hillside, where our modern apartments featuring vaulted ceilings are designed to inspire. If you're searching for an airy and spacious home in Amarillo, our beautifully crafted residences provide the perfect setting for you to thrive.\n\nThese thoughtfully designed apartments offer elegance and comfort, complete with amenities like a fully equipped kitchen and a state-of-the-art Business Center. Located on Hillside Rd, this vibrant community also features a Bark Park and online rental payments, adding ease and convenience to your daily life. At The Colonies, we elevate your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Vaulted Ceilings Amarillo",
      "seo_description": "Explore modern apartments with vaulted ceilings in Amarillo at The Colonies. Enjoy sophisticated design and premium amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-i40-amarillo-colonies",
      "search_query": "fitness center apartments near I-40 Amarillo",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near I-40 Amarillo",
      "h2_subtitle": "Discover fitness center apartments near I-40 in Amarillo. The Colonies at Hillside offers convenience with a healthy lifestyle.",
      "page_copy": "Welcome to The Colonies at Hillside, where our fitness center-equipped apartments are conveniently located near I-40 in Amarillo, offering easy access to the city's main thoroughfares. Residents looking for fitness center apartments near I-40 will find our community an ideal blend of convenience and modern amenities.\n\nStay active with our cutting-edge fitness facilities designed to support your wellness journey. After a workout, relax in our spacious floor plans or head to the Business Center & Cyber Cafe for some work or study. Positioned on Hillside Rd, The Colonies provide both convenience and comfort for your lifestyle needs. Experience exceptional living today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near I-40 Amarillo",
      "seo_description": "Live at The Colonies, with fitness center apartments near I-40 Amarillo. Enjoy convenience and a healthy lifestyle. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-amarillo-tx-colonies",
      "search_query": "1 bedroom apartments in Amarillo TX",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Amarillo, TX",
      "h2_subtitle": "Explore our 1 bedroom apartments in Amarillo, TX. The Colonies at Hillside offers modern living options tailored for you.",
      "page_copy": "Welcome to The Colonies at Hillside, where our 1 bedroom apartments in Amarillo, TX, are designed to provide comfort and style. Perfect for singles or couples, these homes offer a sophisticated living experience with spacious floor plans and a fully equipped kitchen that suits all your needs.\n\nLocated in the vibrant community of Amarillo, TX, our apartments not only offer modern interiors but also a variety of amenities such as a Business Center & Cyber Cafe, and a Bark Park for pet lovers. Enjoy the convenience of online rental payments, making life at The Colonies both easy and enjoyable. Embrace a lifestyle of comfort today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Amarillo, TX",
      "seo_description": "Discover 1 bedroom apartments in Amarillo, TX at The Colonies. Enjoy modern amenities and stylish living. Contact us today for more information!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-randall-county-colonies",
      "search_query": "2 bedroom apartments in Randall County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Randall County",
      "h2_subtitle": "Find your perfect 2 bedroom apartments in Randall County. The Colonies at Hillside offer comfort and style in every unit.",
      "page_copy": "Discover the charm and convenience of living at The Colonies at Hillside, where you can find spacious 2 bedroom apartments in Randall County. Our thoughtfully designed homes provide the ideal blend of comfort and modern amenities, making them perfect for families or roommates.\n\nLocated in Amarillo, The Colonies offers more than just a place to live. Enjoy spacious, well-appointed interiors with fully equipped kitchens, a Business Center & Cyber Cafe, and a Bark Park. These features make day-to-day living a breeze, while our location ensures you're close to everything Randall County has to offer. Experience exceptional living at The Colonies today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Randall County",
      "seo_description": "Explore 2 bedroom apartments in Randall County at The Colonies. Enjoy modern amenities and spacious living. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-college-tx-colonies",
      "search_query": "apartments near amarillo college tx",
      "category": "School",
      "h1_title": "Apartments Near Amarillo College, TX",
      "h2_subtitle": "Discover quality apartments near Amarillo College, TX. The Colonies at Hillside offers convenience for students and professionals alike.",
      "page_copy": "Located just a short drive from Amarillo College, The Colonies at Hillside features apartments perfect for students and professionals seeking convenient living arrangements. Our community offers a range of amenities that enhance your living experience, including spacious floor plans and a fully equipped kitchen, ideal for meal prepping or entertaining guests.\n\nThe Colonies supports your lifestyle by providing easy access to Amarillo College, along with a Business Center & Cyber Cafe to support study needs. Plus, with a convenient location off Hillside Rd, you're affordably connected to all local attractions while enjoying the peaceful ambiance of our charming neighborhood. Join us at The Colonies for a rewarding living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo College, TX",
      "seo_description": "Find apartments near Amarillo College, TX at The Colonies. Enjoy convenient access and modern amenities. Contact us today to learn more!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-close-to-amarillo-college-west-campus",
      "search_query": "apartments close to amarillo college west campus randall county",
      "category": "School",
      "h1_title": "Apartments Close to Amarillo College West",
      "h2_subtitle": "Find the ideal apartments close to Amarillo College West Campus in Randall County at The Colonies at Hillside.",
      "page_copy": "The Colonies at Hillside offers the perfect location for those seeking apartments close to Amarillo College West Campus in Randall County. Our community is ideal for students and faculty members alike, providing a convenient and comfortable living environment. Experience the ease of commuting while enjoying our modern amenities.\n\nOur apartments feature spacious interiors and fully equipped kitchens, making them perfect for those who appreciate style and function. With a Business Center & Cyber Cafe and a Bark Park on-site, The Colonies is committed to meeting the needs of every resident. Conveniently located in Randall County, our apartments provide quick access to Amarillo College West Campus, ensuring you’re never far from where you need to be.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Amarillo College West",
      "seo_description": "Discover apartments close to Amarillo College West Campus in Randall County. The Colonies offers convenient, stylish living. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-near-bsa-hospital-amarillo-colonies",
      "search_query": "apartments near BSA Hospital Amarillo",
      "category": "Hospital",
      "h1_title": "Apartments Near BSA Hospital Amarillo",
      "h2_subtitle": "Looking for apartments near BSA Hospital Amarillo? The Colonies at Hillside offers prime living close to work and amenities.",
      "page_copy": "The Colonies at Hillside presents an excellent living solution with its apartments near BSA Hospital Amarillo. Our location is perfect for healthcare professionals and their families looking to minimize their commute. Enjoy living in a community that combines convenience with comfort.\n\nOur spacious floor plans and fully equipped kitchens cater to busy lifestyles, while community amenities like the Business Center & Cyber Cafe and Bark Park offer added convenience. Being strategically located in Amarillo means you're not only close to BSA Hospital but also enjoy the benefits of local dining and shopping. Experience comfortable, efficient living at The Colonies.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BSA Hospital Amarillo",
      "seo_description": "Explore apartments near BSA Hospital Amarillo at The Colonies. Enjoy modern amenities and a convenient location. Contact us today for more details!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-close-to-northwest-texas-healthcare-system",
      "search_query": "apartments close to Northwest Texas Healthcare System Randall County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Northwest Texas Healthcare",
      "h2_subtitle": "Explore apartments close to Northwest Texas Healthcare System in Randall County. Discover convenience and comfort at The Colonies at Hillside.",
      "page_copy": "The Colonies at Hillside is an ideal community offering apartments close to Northwest Texas Healthcare System in Randall County. This proximity makes it convenient for medical professionals, staff, and patients seeking temporary or long-term accommodations. Enjoy a vibrant community that caters to a variety of needs with spacious living areas and top-notch amenities.\n\nOur residents benefit from amenities that include a fully equipped kitchen perfect for meal preparations, as well as a Business Center & Cyber Cafe that supports work-from-home needs. Situated in the desirable Randall County, The Colonies stands out by providing easy access not only to healthcare facilities but also to shopping and dining options, making everyday living even more enjoyable.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Northwest Texas Healthcare",
      "seo_description": "Find apartments close to Northwest Texas Healthcare System in Randall County. Enjoy quick access and superior amenities at The Colonies.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-botanical-gardens",
      "search_query": "apartments near amarillo botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Amarillo Botanical Gardens",
      "h2_subtitle": "Discover the perfect apartments near Amarillo Botanical Gardens. The Colonies at Hillside offers comfort in a serene setting.",
      "page_copy": "Experience the peaceful environment of The Colonies at Hillside, offering apartments near Amarillo Botanical Gardens. Our community is ideally situated for nature enthusiasts who enjoy aromatic floral displays and serene walking paths just a short drive away. Enjoy the perfect blend of urban convenience and natural beauty with a home at The Colonies.\n\nThe spacious floor plans and fully equipped kitchens in our apartments enhance your living experience. Our community amenities, such as the Business Center & Cyber Cafe, allow you to stay connected while enjoying the lush green spaces around Amarillo. Located close to the botanical gardens, The Colonies offers more than just a place to live—it’s a place to enjoy life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo Botanical Gardens",
      "seo_description": "Explore apartments near Amarillo Botanical Gardens at The Colonies. Enjoy serene surroundings and modern living. Contact us now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartments-close-to-john-stiff-memorial-park-amarillo",
      "search_query": "apartments close to john stiff memorial park amarillo",
      "category": "Park",
      "h1_title": "Apartments Close to John Stiff Memorial Park",
      "h2_subtitle": "Find apartments close to John Stiff Memorial Park in Amarillo. The Colonies at Hillside offers perfect living for active lifestyles.",
      "page_copy": "The Colonies at Hillside provides perfect living accommodations in apartments close to John Stiff Memorial Park, Amarillo's popular destination for outdoor activities. Our prime location offers you easy access to the park's wide-open spaces, walking trails, and recreational facilities, ideal for families and individuals who love staying active.\n\nEnjoy the luxury of spacious floor plans and fully equipped kitchens at The Colonies. Complemented by amenities such as a Bark Park and Business Center, our community supports both your leisure and professional needs. Embrace life near John Stiff Memorial Park, as The Colonies ensures comfort and convenience in Amarillo's vibrant setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to John Stiff Memorial Park",
      "seo_description": "Discover apartments close to John Stiff Memorial Park in Amarillo. Enjoy recreation and comfort at The Colonies. Learn more today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "living-near-wildcat-bluff-nature-center-tx",
      "search_query": "living near wildcat bluff nature center tx",
      "category": "Park",
      "h1_title": "Living Near Wildcat Bluff Nature Center",
      "h2_subtitle": "Experience the beauty of living near Wildcat Bluff Nature Center, TX. The Colonies at Hillside offers a perfect blend of nature and comfort.",
      "page_copy": "Experience serene living near Wildcat Bluff Nature Center, TX, at The Colonies at Hillside. Our community is perfect for nature lovers seeking easy access to the center’s beautiful landscapes and hiking trails. Enjoy an active lifestyle in a tranquil setting, surrounded by Amarillo's stunning natural beauty.\n\nThe Colonies offers expansive floor plans and modern amenities, including a fully equipped kitchen and a convenient Business Center & Cyber Cafe, ensuring a comfortable lifestyle. Being close to Wildcat Bluff means you’re perfectly positioned to explore nature's wonders while enjoying the comforts of home. Discover how living near the nature center can elevate your lifestyle at The Colonies.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Wildcat Bluff Nature Center, TX",
      "seo_description": "Explore living near Wildcat Bluff Nature Center, TX, at The Colonies. Enjoy nature and modern amenities for an enhanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "apartment-homes-by-memorial-park-amarillo-79119",
      "search_query": "apartment homes by memorial park amarillo 79119",
      "category": "Park",
      "h1_title": "Apartment Homes by Memorial Park Amarillo",
      "h2_subtitle": "Find charming apartment homes by Memorial Park in Amarillo, 79119. The Colonies at Hillside balances nature with convenience.",
      "page_copy": "Discover the charm of apartment homes by Memorial Park, Amarillo, located in the 79119 area at The Colonies at Hillside. Our community offers you the proximity to Memorial Park's serene greenery and recreational options, making it an ideal choice for relaxation and leisure.\n\nThe Colonies features spacious floor plans and modern amenities, ensuring a quality living experience. Amenities such as a Bark Park and Online Rental Payments cater to modern living needs. Living near Memorial Park allows residents to enjoy peaceful walks and community events, providing a balanced lifestyle of comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Memorial Park Amarillo",
      "seo_description": "Explore apartment homes by Memorial Park, Amarillo at The Colonies. Enjoy nature and modern amenities. Contact us in 79119!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167037",
      "source": "generator",
      "page_item_url": "rentals-near-medical-center-park-randall-county",
      "search_query": "rentals near medical center park randall county",
      "category": "Park",
      "h1_title": "Rentals Near Medical Center Park in Randall County",
      "h2_subtitle": "Explore quality rentals near Medical Center Park, Randall County. The Colonies at Hillside offers convenience and comfort in a prime location.",
      "page_copy": "The Colonies at Hillside presents exceptional rentals near Medical Center Park, situated in Randall County. This location is perfect for those seeking the convenience of nearby medical facilities along with the tranquility of a park setting. Whether you work in the healthcare sector or enjoy being close to medical services, our community serves your needs effortlessly.\n\nFeaturing spacious floor plans and amenities such as a Business Center & Cyber Cafe, The Colonies ensures a fulfilling living experience. Our modern rentals offer a fully equipped kitchen and Bark Park, all within reach of Medical Center Park's walking trails and open areas. Experience seamless living with convenience and comfort in Randall County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Medical Center Park, Randall County",
      "seo_description": "Discover rentals near Medical Center Park in Randall County at The Colonies. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5160"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-PLL96ZW2MD"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151002"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/colonies-at-hillside/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WJ5SD87F"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167037/019d1bda-3ad9-740b-bfb2-e7401b5fc201.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "842c6a95-48ca-4dbc-9fec-f269b89c5e29"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-940-5093"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af5ba03723ddf0f25aae"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik5LRDRBZ1NHQURSUWF3a3FvUTdXN3c9PSIsInZhbHVlIjoieGtnMzRRLzQyaUZhSlROMWkrSUlwUT09IiwibWFjIjoiYmJmOGE0OWQyZjEyYjIyNmZlNDcwMzE0Mjk3MDA3N2VkOGMzNjQzZWI0N2Y1NjNkOTI2ZmZhMGU4ZmY0YmQ4ZiJ9"
    }
  ],
  "custom_qb_id": "5160",
  "custom_ga4_id": "G-PLL96ZW2MD",
  "custom_repli_id": "10041151002",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/colonies-at-hillside/register/",
  "custom_google_gtm_id": "GTM-WJ5SD87F",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167037/019d1bda-3ad9-740b-bfb2-e7401b5fc201.pdf",
  "custom_rentgrata_property_id": "842c6a95-48ca-4dbc-9fec-f269b89c5e29",
  "custom_ppc_tracking_phone_number": "855-940-5093",
  "custom_residentboost_apartment_id": "6504af5ba03723ddf0f25aae",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik5LRDRBZ1NHQURSUWF3a3FvUTdXN3c9PSIsInZhbHVlIjoieGtnMzRRLzQyaUZhSlROMWkrSUlwUT09IiwibWFjIjoiYmJmOGE0OWQyZjEyYjIyNmZlNDcwMzE0Mjk3MDA3N2VkOGMzNjQzZWI0N2Y1NjNkOTI2ZmZhMGU4ZmY0YmQ4ZiJ9"
};

export const generatedAt = '2026-08-27T21:33:36.250Z';
